var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPerson = function SvgPerson(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.256 103.405C96.234 86.558 81.892 73.5 64.5 73.5c-17.788 0-32.386 13.66-33.875 31.063"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 54,
    r: 19
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPerson);
export default ForwardRef;